import UserObj from 'models/user-obj'
import React from 'react'

interface UserInfoProps {
	user: UserObj
	className?: string
	onClick?(): void
	showRole?: boolean
}

const UserInfo = ({ user, className, onClick, showRole }: UserInfoProps) => {
	return (
		<div className="flex flex-col">
			{onClick ? (
				<button
					type="button"
					onClick={onClick}
					className={`text-sm appearance-none text-left active:ring-none focus:ring-0 p-0 m-0 border-0 ${
						className || ''
					}`}
				>
					{user?.attributes?.firstname} {user?.attributes?.lastname}{' '}
					{showRole && <small className="ml-1">({user.attributes.role})</small>}
				</button>
			) : (
				<span className="block break-all text-sm font-semibold">
					{user?.attributes?.firstname} {user?.attributes?.lastname}
					{showRole && <small className="ml-1">({user.attributes.role})</small>}
				</span>
			)}
			<span className="text-xs text-gray-600 break-all">
				<a href={'mailto:' + user?.attributes?.email} className="text-blue-500">
					{user?.attributes?.email}
				</a>
			</span>
			{user?.attributes?.phoneNumber && (
				<span className="text-xs">
					<a
						href={'tel:' + user?.attributes?.phoneNumber}
						className="text-blue-500"
					>
						{user?.attributes?.phoneNumber}
					</a>
				</span>
			)}
			{user?.attributes?.linkedinUrl && (
				<span className="text-xs break-all">
					<a
						href={user?.attributes?.linkedinUrl}
						target="_blank"
						className="text-blue-500"
						rel="noreferrer"
					>
						{user?.attributes?.linkedinUrl}
					</a>
				</span>
			)}
		</div>
	)
}

export default UserInfo
